// menuDescriptions.js
const menuDescriptions = [
  {
    id: 'about',
    title: 'About Linkist',
    description: 
      'Linkist is a simple and stylish link-sharing platform designed for creatives, professionals, influencers, and anyone who needs an easy way to share their online presence.\n\n' +
      'With Linkist, you can create a clean, minimal profile showcasing your most important links. Whether you\'re an artist, musician, photographer, or professional, it gives you a dedicated space to organize and present your work.\n\n' +
      'For influencers and creators with partnerships, Linkist Pro allows you to highlight priority links, ensuring your sponsorships and key content stand out.\n\n' +
      'Our free tier lets you share up to 5 links, while the Pro subscription at just €3 per month unlocks 25 links and premium features.\n\n' +
      'No unnecessary complexity, no complicated setup—just a simple, customizable way to display your links that fits your unique style.',
  },
  {
    id: 'pricing',
    title: 'Tier Features',
    description:
      'FREE\n\n' +
      '• Display up to 5 important links\n' +
      '• Share up to 5 icons\n' +
      '• Upload a profile picture\n' +
      '• Upload a profile banner\n' +
      '• Add a custom bio\n' +
      '• Basic templates\n' +
      '• Over 30 color palattes\n' +
      '• Profile QR Code\n' +
      '• And more customization\n\n' +
      
      'PRO — €3/month\n\n' +
      '• Up to 25 links\n' +
      '• Up to 25 icons\n' +
      '• Full control over link order\n' +
      '• Complete template library\n' +
      '• Priority linking for sponsors\n' +
      '• Custom icon colors\n' +
      '• Profile level Ghost Mode \n' +
      '• Ghost Mode for individual links\n' +
      '• Link analytics\n' +
      '• Link shortener\n\n' +
      
      'NEW FEATURES\n\n' +
      'Pro subscribers get exclusive access to our latest features:\n\n' +
      '• Privacy controls — Hide individual links or your entire profile\n' +
      '• Secure link storage — Keep links private until ready to share\n' +
      '• Click tracking — Monitor engagement with your content\n' +
      '• Advanced customization — Make your profile truly yours',
  },
  {
    id: 'terms',
    title: 'Terms and Conditions',
    description:
      'Welcome to Linkist. By accessing and using our platform, you agree to comply with the following Terms and Conditions.\n\n' +
      
      '1. GENERAL USE\n\n' +
      '• Linkist provides users with the ability to store and share links, images, and content.\n' +
      '• You must be at least 13 years old to use Linkist. If under 18, you require parental consent.\n' +
      '• We reserve the right to modify or terminate any feature at any time without prior notice.\n\n' +
      
      '2. USER RESPONSIBILITIES\n\n' +
      '• You are responsible for any content (links, images, text, or other material) that you upload or share.\n' +
      '• You agree NOT to distribute, host, or store:\n' +
      '  - Illegal, defamatory, abusive, or hateful content\n' +
      '  - Pornographic, explicit, or adult material\n' +
      '  - Material infringing on intellectual property\n' +
      '  - Malicious software, viruses, or harmful code\n' +
      '• You acknowledge that uploaded content must comply with applicable laws.\n\n' +
      
      '3. IMAGE UPLOAD POLICY\n\n' +
      '• By uploading images, you confirm ownership or necessary permissions.\n' +
      '• We do not claim ownership but retain the right to host and display them.\n' +
      '• We may remove images that violate these Terms.\n\n' +
      
      '4. LINKIST\'S LIABILITY\n\n' +
      '• Linkist does not endorse, monitor, or verify any links saved by users.\n' +
      '• Clicking or sharing user-generated links is at your own risk.\n' +
      '• Linkist is not liable for any damage, loss, or legal consequences from user content.\n' +
      '• We do not guarantee the availability, accuracy, or security of third-party links.\n\n' +
      
      '5. ACCOUNT AND TERMINATION\n\n' +
      '• We reserve the right to suspend or terminate any account that violates these Terms.\n' +
      '• If your account is terminated, you will lose access to stored links or content.\n\n' +
      
      '6. PRIVACY AND DATA USE\n\n' +
      '• Your privacy is important to us. See our Privacy Policy for details.\n' +
      '• We do not sell personal data to third parties.\n\n' +
      
      '7. CHANGES TO THESE TERMS\n\n' +
      '• We may update these Terms from time to time. Continued use of Linkist after updates constitutes acceptance of the revised Terms.\n\n' +
      
      '8. CONTACT\n\n' +
      'If you have any questions regarding these Terms, please contact us at:\n' +
      'accounts@linkist.se',
  },
  // Add more items as needed
  // Add this to your menuDescriptions.js array
{
  id: 'howitworks',
  title: 'How It Works',
  description:
    'Linkist makes sharing your online presence simple in 3 easy steps:\n\n' +
    '1. SIGN UP\n\n' +
    '• Create a free account in seconds\n' +
    '• Choose your custom username\n' +
    '• Upload a profile picture\n\n' +
    
    '2. ADD YOUR LINKS\n\n' +
    '• Add up to 5 links (Free) or 25 links (Pro)\n' +
    '• Select icons for each platform\n' +
    '• Customize with your brand colors\n' +
    '• Choose from multiple themes\n\n' +
    
    '3. SHARE WITH THE WORLD\n\n' +
    '• Get your personal Linkist URL (linkist.se/yourusername)\n' +
    '• Share on social media and in your bio\n' +
    '• Use the QR code for in-person networking\n' +
    '• Track clicks with analytics (Pro)\n\n' +
    
    'PRO BENEFITS\n\n' +
    '• More links and icons (up to 25)\n' +
    '• Priority link placement for sponsors\n' +
    '• Custom icon colors\n' +
    '• Profile banner upload\n' +
    '• Ghost Mode for private links\n' +
    '• Click tracking & analytics\n' +
    '• And much more for just €3/month'
}
];

export default menuDescriptions;